<template>
  <div class="widget w-renderer-widget">
    <c-widget-header>
      {{ label }}
      <slot name="buttons" slot="buttons" />
    </c-widget-header>

    <c-widget-control-bar>
      <h4 class="text-primary">This is a test widget, do not use in production!</h4>
    </c-widget-control-bar>

    <div class="widget-body">
      <c-advances-declines
        :label="$t('white-label.widgets.portfolio.labels.advancesDeclines')"
        :advances="advances"
        :declines="declines"
      />
      <div style="height: 50%;">
        <ag-grid-vue
          class="c-data-grid ag-theme-balham-dark"
          style="height: 184px !important"
          animateRows
          :asyncTransactionWaitMillis="gridUpdateInterval"
          suppressContextMenu
          enableSorting
          :suppressFieldDotNotation="true"
          :gridOptions="gridOptions"
          :defaultColDef="defaultColumnDef"
          :columnDefs="columnDefinition"
          :components="renderers"
          immutableData
          ensureDomOrder
          :suppressColumnVirtualisation="isAccessibilityEnabled"
          @async-transactions-flushed="onAsyncTransactionsFlushed"
        />
      </div>
      <v-button block @click="changeRowData">Toggle Data</v-button>
      <div style="height: 50%; overflow: auto;">
        <hr />
        <pre style="color: #fff;">{{ rows }}</pre>
      </div>
    </div>

    <div class="widget-footer">Footer</div>
  </div>
</template>

<script>
import CWidgetHeader from '@custom/widgetContainer/CWidgetHeader';
import CWidgetHeaderButton from '@custom/widgetContainer/CWidgetHeaderButton';
import CWidgetControlBar from '@custom/widgetContainer/CWidgetControlBar';

import { AgGridVue } from 'ag-grid-vue';
import { change as ChangeRulesPack } from '@custom/dataGrid/classRules';
// Renderes
import CAdvancesDeclines from '@custom/CAdvancesDeclines';
import {
  AnalystsRenderer,
  FlagRenderer,
  TickFlashRenderer,
  TrendArrowRenderer,
  PerformanceRenderer,
  RangeRenderer
} from '@custom/dataGrid/renderers';
import { rowHeightM } from '@mm5-components/scss/variables.scss';

const data1 = [
  {
    symbol: 'BA.N',
    country: 'US',
    displayName: 'BOEING CO.',
    price: 370.49,
    change: 8.29,
    trend: 'up',
    changePercentage: {
      performance: 2.29,
      min: -1.21,
      max: 2.29
    },
    weekRange: {
      start: 292.5,
      end: 445.9,
      mark: 400
    },
    analysts: 2
  },
  {
    symbol: 'CAT.N',
    country: 'US',
    displayName: 'CATERPILLAR INC.',
    price: 131.38,
    change: 1.61,
    trend: 'up',
    changePercentage: {
      performance: 1.24,
      min: -1.21,
      max: 2.29
    },
    weekRange: {
      start: 112.1,
      end: 161.5,
      mark: 138.78
    },
    analysts: 2.2857
  },
  {
    symbol: 'VZ.N',
    country: 'US',
    displayName: 'VERIZON COMMUNICATIONS INC.',
    price: 60.08,
    change: 0.32,
    trend: 'up',
    changePercentage: {
      performance: 0.54,
      min: -1.21,
      max: 2.29
    },
    weekRange: {
      start: 46.09,
      end: 61.58,
      mark: 54
    },
    analysts: 2.4444
  },
  {
    symbol: 'AAPL.OQ',
    country: 'US',
    displayName: 'APPLE INC.',
    price: 188.74,
    change: 0,
    trend: 'right',
    changePercentage: {
      performance: 0,
      min: -1.21,
      max: 2.29
    },
    weekRange: {
      start: 142.0,
      end: 233.5,
      mark: 220
    },
    analysts: 2.0513
  },
  {
    symbol: 'WMT.N',
    country: 'US',
    displayName: 'WALMART INC.',
    price: 153.03,
    change: -0.04,
    trend: 'down',
    changePercentage: {
      performance: -0.11,
      min: -1.21,
      max: 2.29
    },
    weekRange: {
      start: 116.0,
      end: 156.8,
      mark: 139.4
    },
    analysts: 2.3235
  },
  {
    symbol: 'DWDP.N',
    country: 'US',
    displayName: 'DOWDUPONT INC.',
    price: 53.27,
    change: -0.65,
    trend: 'down',
    changePercentage: {
      performance: -1.21,
      min: -1.21,
      max: 2.29
    },
    weekRange: {
      start: 48.89,
      end: 71.92,
      mark: 70
    },
    analysts: 2.2
  }
];
const data2 = [
  {
    symbol: 'BA.N',
    country: 'US',
    displayName: 'BOEING CO.',
    price: 370.49,
    change: 0,
    trend: 'right',
    changePercentage: {
      performance: 0,
      min: -1.5,
      max: 2.29
    },
    weekRange: {
      start: 350.0,
      end: 445.9,
      mark: 370
    },
    analysts: 1.5
  },
  {
    symbol: 'CAT.N',
    country: 'US',
    displayName: 'CATERPILLAR INC.',
    price: 131.38,
    change: -1.61,
    trend: 'down',
    changePercentage: {
      performance: -1.24,
      min: -1.5,
      max: 2.29
    },
    weekRange: {
      start: 112.1,
      end: 121.5,
      mark: 120
    },
    analysts: 4.2857
  },
  {
    symbol: 'VZ.N',
    country: 'US',
    displayName: 'VERIZON COMMUNICATIONS INC.',
    price: 70.08,
    change: 0.32,
    trend: 'up',
    changePercentage: {
      performance: 1.54,
      min: -1.5,
      max: 2.29
    },
    weekRange: {
      start: 46.09,
      end: 101.58,
      mark: 59
    },
    analysts: 1.4444
  },
  {
    symbol: 'AAPL.OQ',
    country: 'US',
    displayName: 'APPLE INC.',
    price: 192.74,
    change: 0.56,
    trend: 'up',
    changePercentage: {
      performance: 1.2,
      min: -1.5,
      max: 2.29
    },
    weekRange: {
      start: 222.0,
      end: 233.5,
      mark: 230
    },
    analysts: 1.8513
  },
  {
    symbol: 'WMT.N',
    country: 'US',
    displayName: 'WALMART INC.',
    price: 153.03,
    change: 0.04,
    trend: 'down',
    changePercentage: {
      performance: 0.11,
      min: -1.5,
      max: 2.29
    },
    weekRange: {
      start: 116.0,
      end: 140.8,
      mark: 120
    },
    analysts: 2.1235
  },
  {
    symbol: 'DWDP.N',
    country: 'US',
    displayName: 'DOWDUPONT INC.',
    price: 53.27,
    change: -2.65,
    trend: 'down',
    changePercentage: {
      performance: -1.5,
      min: -1.5,
      max: 2.29
    },
    weekRange: {
      start: 48.89,
      end: 91.92,
      mark: 70
    },
    analysts: 3.2
  }
];

export default {
  name: 'w-renderer-widget',
  components: {
    AgGridVue,
    CWidgetHeader,
    CWidgetHeaderButton,
    CWidgetControlBar,
    CAdvancesDeclines,
    AnalystsRenderer,
    FlagRenderer,
    TickFlashRenderer,
    TrendArrowRenderer,
    PerformanceRenderer,
    RangeRenderer
  },
  props: {
    label: {
      type: String,
      required: true
    }
    // add own props
  },
  data() {
    return {
      // add own data
      rows: data1,
      rowData: 'data1',
      advances: 37,
      declines: 60,
      // Grid ---------------------
      columns: [
        {
          field: 'symbol',
          headerName: `Symbol`,
          resizable: true,
          headerClass: 'text-left',
          cellClass: 'text-left text-primary',
          pinned: 'left'
        },
        {
          field: 'country',
          headerName: `Country`,
          headerClass: 'text-center',
          resizable: true,
          cellClass: 'text-center',
          cellRenderer: 'FlagRenderer'
        },
        {
          field: 'displayName',
          headerName: `Name`,
          resizable: true,
          headerClass: 'text-left',
          cellClass: 'text-left'
        },
        {
          field: 'price',
          headerName: `Price`,
          resizable: true,
          cellRenderer: 'TickFlashRenderer'
        },
        {
          field: 'change',
          headerName: `Change`,
          resizable: true,
          cellClassRules: ChangeRulesPack,
          cellRenderer: 'TickFlashRenderer'
        },
        {
          field: 'trend',
          headerName: `Trend Arrow`,
          resizable: true,
          cellClass: 'text-center',
          cellClassRules: ChangeRulesPack,
          cellRenderer: 'TrendArrowRenderer'
        },
        {
          field: 'changePercentage',
          headerName: `Change %`,
          headerClass: 'text-center',
          resizable: true,
          width: 200,
          cellClassRules: ChangeRulesPack,
          cellRenderer: 'PerformanceRenderer'
        },
        {
          field: 'weekRange',
          headerName: `52 Week Range`,
          headerClass: 'text-center',
          resizable: true,
          sortable: false,
          width: 200,
          cellRenderer: 'RangeRenderer',
          equals(oldVal, newVal) {
            return oldVal.start === newVal.start && oldVal.end === newVal.end;
          }
        },
        {
          field: 'analysts',
          headerName: `Analysts`,
          headerClass: 'text-center',
          width: 200,
          sortable: false,
          cellRenderer: 'AnalystsRenderer'
        }
      ],
      gridOptions: {
        headerHeight: +rowHeightM,
        rowHeight: +rowHeightM,
        getRowNodeId(data) {
          return data.symbol;
        }
      },
      defaultColumnDef: {
        width: 100,
        minWidth: 40,
        headerClass: 'text-right',
        cellClass: 'text-right'
      }
      // --------------------------
    };
  },
  computed: {
    columnDefinition() {
      return this.columns.map(e => {
        return Object.assign({}, e, {
          headerName: e.headerName
        });
      });
    },
    renderers() {
      return [AnalystsRenderer, FlagRenderer, TickFlashRenderer, TrendArrowRenderer, PerformanceRenderer];
    }
  },
  methods: {
    dataGridUpdate() {
      this.gridOptions.api.batchUpdateRowData({ update: this.rows });
    },
    changeRowData() {
      if (this.rowData === 'data1') {
        this.rows = data2;
        this.advances = 70;
        this.declines = 17;
        this.rowData = 'data2';
      } else {
        this.rows = data1;
        this.advances = 37;
        this.declines = 60;
        this.rowData = 'data1';
      }
      this.dataGridUpdate();
    }
  },
  mounted() {
    this.gridOptions.api.batchUpdateRowData({ add: this.rows });
  }
};
</script>

<style lang="scss">
@import '~@/styles/vendor/ag-grid';
</style>
